import * as THREE from "three";
import { useState, useRef, useEffect } from 'react';
import { RigidBody, CapsuleCollider, CuboidCollider, useRapier } from '@react-three/rapier';
import { useFrame, useThree } from '@react-three/fiber';
import { useKeyboardControls } from '@react-three/drei';
import useGame from '../../src/stores/useGame.js'
import useAudioStore from "../stores/useAudioStore.js";

const SPEED = 16;
const direction = new THREE.Vector3();
const frontVector = new THREE.Vector3();
const sideVector = new THREE.Vector3();

let playerInit = true

export default function Player() {

  const ref = useRef();
  const [toggleCollider, setToggleCollider] = useState(true)

  //zustand
  const startCountdown = useGame((state)=>{return state.setCountdown})
  const portalEntered = useGame((state)=>{return state.portalEntered})
  const setPortalEntered = useGame((state)=>{return state.setPortalEntered})
  const countdownEnded = useGame((state)=>{return state.setCountdownEnded})
  const startWalkAudio = useAudioStore((state)=>{return state.startWalkAudio})
  const stopWalkAudio = useAudioStore((state)=>{return state.stopWalkAudio})
  const startTerrorAudio = useAudioStore((state)=>{return state.startTerrorAudio})
  const stopTerrorAudio = useAudioStore((state)=>{return state.stopTerrorAudio})

  //new
  const [ subscribeKeys, getKeys ] = useKeyboardControls()
  const { world } = useRapier();

    let entryPoint = true

    // walking sound
    useEffect(() => {
      const unsubscribeKeys = subscribeKeys(
        // Any movement key
        (state) => {
          return state.forward || state.back || state.left || state.right;
        },
        (value) => {
          if (value) {
            startWalkAudio();
          } else {
            stopWalkAudio();
          }
        })
    return ()=>{
      unsubscribeKeys()
    }
    }, []);

    useEffect(()=>{
        stopTerrorAudio()
    }, [countdownEnded])

  useFrame((state) => {

    console.log(state.camera.position)
    const { forward, back, left, right, jump } = getKeys();
    const velocity = ref.current.linvel();

    // field of view hallway 
    if(state.camera.position. y >= -13 && state.camera.position.z >= -55 && state.camera.position.x >= 140) {

// fov changes - 0.2 default
      state.camera.fov = (state.camera.position.z*0.2) + 61.01
      state.camera.updateProjectionMatrix()
    }

    if(entryPoint) {
      if(state.camera.position.z >=84) {
        entryPoint = false
      }
    }

    // Update camera's position
    state.camera.position.copy(ref.current.translation());

    // Fake player height: Move camera higher in y direction to avoid being stuck with capsule collider
    state.camera.position.y += 6
  
    // Calculate movement direction based on camera's rotation
    frontVector.set(0, 0, back - forward);
    sideVector.set(left - right, 0, 0);
    direction.subVectors(frontVector, sideVector).normalize().multiplyScalar(SPEED).applyEuler(state.camera.rotation);
        
    // Update player's velocity
    ref.current.setLinvel({ x: direction.x, y: velocity.y, z: direction.z });
 
    // Teleport
    if (state.camera.position.y <=-204) {

    // take into account the camera offset of 6 (was -76)
    const newYPositionValue = -146.30862426757812;
  
    ref.current.setTranslation({ x: ref.current.translation().x, y: newYPositionValue, z: ref.current.translation().z });

    // Update camera's position based on player's new position
    state.camera.position.set(state.camera.position.x, state.camera.position.y, state.camera.position.z);
    }

    //Exit portal
    // if (portalEntered) {
    //   // setPortalEntered()
    //   stopTerrorAudio()
    //   stopWalkAudio()
    // }

  // low player y at starting position workaround
  if(playerInit) {
    if(ref.current.translation().x === -14 && ref.current.translation().y < -18.41 && ref.current.translation().z === -40) {
      // console.log('before', ref.current.translation().y)
      ref.current.setTranslation({ x: ref.current.translation().x, y: -15, z: ref.current.translation().z });
        // console.log('after', ref.current.translation().y)
        playerInit = false
        console.log('low y player triggered!')
    }
  }
  });
 
  return ( 
    <>

    {/* og player position */}
    <RigidBody friction={0}  linearDamping={1} canSleep={false} ref={ref}  colliders={false} mass={1} type="KinematicPositionBased" position={[-14, 
-16, -40]} enabledRotations={[false, false, false]} world={world}>

  {/* player test position before door entry for debugging */}
    {/* <RigidBody friction={0}  linearDamping={1} canSleep={false} ref={ref}  colliders={false} mass={1} type="KinematicPositionBased" position={[153, 
-16, 40]} enabledRotations={[false, false, false]} world={world}> */}

  {/* player capsule collider */}
      <CapsuleCollider args={[0.2, 1.5]} />
    </RigidBody>

    {/* {portal collider} */}
    <CuboidCollider
      args={[1, 100, 100]}
      // position={[245,-96,166]}
      position={[273,-96,166]}
      debug
      sensor
      onIntersectionEnter={() => {
        stopTerrorAudio()
        stopWalkAudio()
        setPortalEntered()
      }}/>

    {toggleCollider && <CuboidCollider
      args={[1000, 10, 1000]}
      position={[150,-203,70]}
      sensor
      onIntersectionEnter={() => {
        console.log('intersection enter of cosmic horror')
        startTerrorAudio()
        startCountdown()
      }}
      onIntersectionExit={()=>{
        setToggleCollider(false)}}
    />}
    </>
  );
}


